import { Controller } from '@hotwired/stimulus'
import { PreviewClient } from 'api/preview_client'
import { FileAttacher, disablingSubmitButtonOnUpload } from 'api/file_attacher'
import dragDrop from 'drag-drop'
import { Confirmable, ConfirmableEvent } from 'mixins/confirmable'
class DailyReportCommentEditor extends Confirmable(Controller) {
  connect () {
    this.initConfirmableForms([this.formTarget.id])
    this.currentBody = this.bodyTarget.value
    this.client = new PreviewClient({ previewTarget: this.previewTarget, bodyTarget: this.bodyTarget })
    // NOTE: data-targetを指定するとBootstrapのtabの挙動が怪しくなる為、ここでは使用していない
    const formTab = this.selfTarget.querySelector('.js-form-tab')
    if (formTab === null) {
      throw new Error('No formTab')
    }
    this.formTab = formTab
    const previewTab = this.selfTarget.querySelector('.js-preview-tab')
    if (previewTab === null) {
      throw new Error('No previewTab')
    }
    this.previewTab = previewTab
    this.fileAttacher = new FileAttacher({ bodyTarget: this.bodyTarget, callback: disablingSubmitButtonOnUpload(this.submitTarget) })
    dragDrop(this.bodyTarget, (files) => {
      this.fileAttacher.uploadFiles(files, window)
    })
    this.uploadButtonTarget.disabled = false
    if (this.selfTarget.dataset.commentId === undefined) {
      this.cancelButtonTarget.style.display = 'none'
      this.cancelButtonPreviewTarget.style.display = 'none'
    }
  }

  pasteClipboardData (e) {
    if (e.clipboardData.types.indexOf('Files') > -1) {
      this.fileAttacher.uploadFiles(Array.from(e.clipboardData.files), window)
      e.preventDefault()
    }
  }

  focusPreview () {
    this.updatePreview()
    this.previewTab.focus()
  }

  switchTab (e) {
    if (e.code === 'KeyP' && e.shiftKey && (e.ctrlKey || e.metaKey)) {
      e.preventDefault()
      if (this.formTab.classList.contains('active')) {
        this.updatePreview()
        this.previewTab.click()
        this.previewTab.focus()
      } else {
        this.formTab.click()
        this.formTab.addEventListener('shown.bs.tab', () => {
          this.bodyTarget.focus()
        })
      }
    }
  }

  clickFileUploadButton (e) {
    e.preventDefault()
    this.filesTarget.click()
  }

  changeFiles () {
    const files = this.filesTarget.files
    if (files === null) {
      throw new Error('No files founds')
    }
    this.fileAttacher.uploadFiles(Array.from(files), window)
  }

  toggle () {
    const commentForm = this.selfTarget.querySelector('.comment-form__comment')
    if (commentForm === null) {
      throw new Error('No commentForm found')
    }
    if (commentForm.classList.contains('d-none')) {
      this.close()
    } else {
      this.open()
    }
  }

  open () {
    // NOTE: DailyReportCommentFormComponent で新規作成時・編集時のどちらかでしか
    //       利用されない要素はtargetではなくクラス指定にしている
    const comment = this.selfTarget.querySelector('.comment-form__comment')
    const editor = this.selfTarget.querySelector('.js-comment-editor')
    if (comment) comment.classList.add('d-none')
    if (editor) editor.classList.remove('d-none')
    this.editIconTarget.classList.add('comment-form__editing')
  }

  close () {
    // NOTE: DailyReportCommentFormComponent で新規作成時・編集時のどちらかでしか
    //       利用されない要素はtargetではなくクラス指定にしている
    const comment = this.selfTarget.querySelector('.comment-form__comment')
    const editor = this.selfTarget.querySelector('.js-comment-editor')
    if (comment) comment.classList.remove('d-none')
    if (editor) editor.classList.add('d-none')
    this.editIconTarget.classList.remove('comment-form__editing')
    this.bodyTarget.value = this.currentBody
    this.formTarget.dispatchEvent(new Event(ConfirmableEvent.reset))
  }

  updatePreview () {
    this.previewTarget.innerHTML = ''
    this.client.call(100)
  }
}
DailyReportCommentEditor.targets = ['self', 'preview', 'body', 'files', 'submit',
  'uploadButton', 'cancelButton', 'cancelButtonPreview', 'editIcon', 'form']
export default DailyReportCommentEditor
